import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { PpsUtilityService } from '../services/pps-utility.service';
import { User } from '../shared/models/user';

@Component({
  selector: 'pps-user-selection-form',
  templateUrl: './user-selection-form.component.html',
  styles: [
  ],
})
export class UserSelectionFormComponent implements OnInit {
  userList: User[] = [];
  selectedUsers: User[] = [];

  constructor(
    private _dialogRef: DynamicDialogRef,
    private _dialogConfig: DynamicDialogConfig,
    private _util: PpsUtilityService
  ) { }

  ngOnInit(): void {
    this.userList = this._dialogConfig.data.userList;
  }

  getFullname(user: User){
    return this._util.getEmployeeName({firstName: user.firstName, lastName: user.lastName});
  }

  save(form: NgForm){
    console.log(form);

    if (this.selectedUsers.length === 0){
      this._dialogRef.close();
    }else{
      this._dialogRef.close(this.selectedUsers);
    }
  }

  cancel(){
    this._dialogRef.close();
  }

}
